<template>
  <div class="box">
    <el-row :gutter="10">
      <el-col :span="12"
              v-for="item in listArr"
              :key="item.jobCode">
        <info :item="item"></info>
      </el-col>
    </el-row>
    <el-pagination background
                   v-if="listArr.length>0"
                   @current-change="handleCurrentChange"
                   :current-page="currentPage"
                   :page-size="size"
                   layout="prev, pager, next"
                   :total="total">
    </el-pagination>
  </div>
</template>

<script>
import info from '@/components/info'

export default {
  components: {
    info,
  },
  data () {
    return {
      currentPage: 1,
      size: 12,
      listArr: [],
      total: 0
    }
  },
  created () {
    this.getListInfo(this.currentPage);
  },
  methods: {
    getListInfo (page) {
      let param = {
        type: 1,
        pageNo: page,
        pageSize: this.size,
        jobType: 1
      };
      this.$get("/app/api/v1/verify/all", param)
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.listArr = res.data.info;
            this.total = res.data.total;
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        })
        .catch((err) => { });
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getListInfo(this.currentPage);
    }
  },
}
</script>

<style scoped>
.box {
  width: 100%;
  margin-top: 10px;
  padding: 5px 15px 30px;
  border: 1px solid #f5f5f5;
}
>>> .el-pagination {
  text-align: center;
  margin-top: 30px;
}
>>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #e53631;
}
</style>